import { CardContent, TextField } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import { StyleRules, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ChevronRight from '@material-ui/icons/ChevronRight';
import CreditCard from '@material-ui/icons/CreditCard';
import { default as i18n, default as i18next } from 'i18next';
import * as _ from 'lodash';
import * as React from 'react';
import { Fragment } from 'react';
import { Trans } from 'react-i18next';
import { Navigate } from 'react-router';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import '../i18n';
import ARHttp from '../services/ARHttp';
import ErrorMessages from './ErrorMessages';
import PendingIcon from './PendingIcon';
import ScarecrowPropertiesService from '../services/ScarecrowPropertiesService';

const elavonLogo = require('../assets/images/ElavonLogo.png');

declare const grecaptcha: any;

const pageStyles: StyleRules = {
  pageHeader: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.24)',
    padding: '0px !important',
    paddingTop: '5px !important',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
  },
  avatarIcon: {
    color: '#585858',
    fontSize: '34px',
    paddingTop: '4px',
    marginRight: '-12px',
  },
  headerText: {
    fontSize: '28px',
  },
  pageContent: {
    backgroundColor: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    flexDirection: 'column',
  },
  cardContent: {
    padding: '0px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    flexDirection: 'column',
  },
  genericFormControl: {
    marginTop: '18px',
    marginBottom: '4px',
  },
  genericInput: {
    marginTop: '18px',
    marginBottom: '4px',
    width: '315px',
  },
  submitButton: {
    backgroundColor: '#2c7bbc',
    width: '230px',
  },
  buttonForm: {
    display: 'inline-block',
    marginTop: '8px',
  },
  signInCaption: {
    paddingTop: '24px',
    fontSize: '16px',
    display: 'block',
  },
  errors: {
    color: '#f44336',
    fontSize: '12px',
  },
  subText: {
    color: 'rgba(0, 0, 0, 0.54)',
    width: '315px',
    fontSize: '12px',
  },
  elavonLogo: {
    padding: '16px',
    maxHeight: '49px',
    maxWidth: '108px',
  },
  jurisdictionLogo: {
    padding: '8px',
    maxHeight: '75px',
    maxWidth: '215px',
  },
};

let signInURL = 'https://www.mypaymentsinsider.com/ui/#/us/en_US/login';
const passwordMinimumLength = 14;

// Regex patterns. If we use these elsewhere, they should be moved into their own file.
const alphaCharsPattern = 'a-zA-Z';
const digitsPattern = '0-9';
const alphaNumericPattern = alphaCharsPattern + digitsPattern;
const validEmailNamePattern = `[${alphaNumericPattern}\\._+\\-]+`;
const validEmailServerPattern = `(?:[${alphaNumericPattern}\\-]+\\.)+`;
const validEmailDomainPattern = `[${alphaCharsPattern}]{2,}`;
const emailValidationPattern = `^${validEmailNamePattern}@${validEmailServerPattern}${validEmailDomainPattern}$`;

const specialCharsPattern = "<>@!#$%^&*()_+[]{}?:;|'\"\\,./~`-=";
const internationalCharactersPattern = '\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF'; // international characters such as ä é
const nameValidationPattern = `^([${internationalCharactersPattern}${alphaCharsPattern}^\\s]|[^${specialCharsPattern}]).*?$`;

const lowercasePattern = '.*[a-z].*';
const uppercasePattern = '.*[A-Z].*';
const digitPattern = '.*[0-9].*';
const specialPattern = '.*[!#$%&*].*';

class RegisterScreen extends React.Component<any, any> {
  constructor(props) {
    super(props);

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleCountryChange = this.handleCountryChange.bind(this);
    this.createAccount = this.createAccount.bind(this);
    this.handleServerError = this.handleServerError.bind(this);
    this.handleServerResponse = this.handleServerResponse.bind(this);

    this.state = {
      emailAddress: '',
      fullName: '',
      password: '',
      country: 'USA',
      disabled: true,
      redirect: false,
      pending: false,
      offerCode: undefined,
      passwordMinLength: 14,
      pristine: {
        emailAddress: true,
        fullName: true,
        password: true,
      },
      errors: {
        email: {
          emailRequired: false,
          emailPattern: false,
          emailInUse: false,
        },
        name: {
          nameRequired: false,
          namePattern: false,
        },
        password: {
          passwordRequired: false,
          passwordPattern: false,
          passwordMinLength: false,
        },
        server: {
          serverError: false,
        },
      },
      jurisdictionCode: undefined,
      locale: '',
      subJurisdictionCode: undefined,
    };
  }

  public componentDidMount() {
    window.document.title = i18next.t('register_screen_window_title');
    ScarecrowPropertiesService.subscribe({
      next: (function (props) {
        this.setState((state) => ({ ...state, passwordMinLength: props.passwordMinLength }));
      }).bind(this),
    });

    if (this.props.location) {
      const params = new URLSearchParams(this.props.location.search);

      let jurisdictionCode = params.get('jc');
      let locale = params.get('locale');
      const offerCode = params.get('offering');
      const subJurisdictionCode = params.get('sj');

      if ((!jurisdictionCode) && (!subJurisdictionCode)) {
        jurisdictionCode = 'SBUS';
      }

      // TODO: Add real jurisdiction code and real sign in URL
      if (jurisdictionCode === 'SBCSTCUSA' && locale === 'en_US') {
        signInURL = 'https://www.mypaymentsinsider.com/ui/#/us/en_US/login';
      }

      if (locale === 'en_CA') {
        signInURL = 'https://www.mypaymentsinsider.com/ui/#/us/en_CA/login';
      }

      if (locale === 'fr_CA') {
        signInURL = 'https://www.mypaymentsinsider.com/ui/#/ca/fr_CA/login';
      }

      if (!locale) {
        locale = 'en_US';
      }

      if (locale === 'pl_PL') {
        signInURL = 'https://www.elavonconnect.com/ui/#/eu/pl_PL/login';
      }

      if (locale === 'en_GB') {
        signInURL = 'https://www.elavonconnect.com/ui/#/eu/en_GB/login';
      }

      this.setState({
        jurisdictionCode,
        locale,
        subJurisdictionCode,
      });

      // istanbul ignore else
      if (offerCode) {
        this.setState({
          offerCode,
        });
      } else if (process.env.NODE_ENV !== 'development') {
        window.location.assign('https://www.elavon.com/our-services/small-business/pricing-apply-now.html');
      }
    }
  }

  public render() {
    // Error message strings.
    const minLength = this.state.passwordMinLength;

    if (this.state.redirect) {
      return (
        <Navigate
          to="/verifyEmail"
          state={{
            emailAddress: this.state.emailAddress,
            name: this.state.fullName,
            jurisdictionCode: this.state.jurisdictionCode,
            locale: this.state.locale,
            offerCode: this.state.offerCode,
            subJurisdictionCode: this.state.subJurisdictionCode,
          }}
        />
      );
    }
    const classes = this.props.classes!;
    const avatar = (
      <Typography>
        <CreditCard className={classes.avatarIcon} />
      </Typography>
    );
    const title = (
      <Typography variant="h5" className={classes.headerText}>
        <Trans>create_your_account</Trans>
      </Typography>
    );

    return (
      <>
        <Card className={classes.pageContent}>
          <img src={elavonLogo} alt="icon" className={classes.elavonLogo} />
          <CardHeader className={classes.pageHeader} title={title} avatar={avatar} />
          <CardContent className={classes.cardContent}>
            <form onSubmit={this.createAccount} className={classes.cardContent}>
              <Grid item xs={12}>
                <TextField
                  id="emailAddress"
                  label={i18next.t('business_email')}
                  placeholder="email@domain.com"
                  className={classes.genericInput}
                  value={this.state.emailAddress}
                  onChange={this.handleInputChange}
                  error={this.hasEmailErrors()}
                  helperText={
                    this.hasEmailErrors() ? (
                      <ErrorMessages show={this.getEmailErrors()} messages={this.getEmailErrorMessages()} />
                    ) : (
                      ''
                    )
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="fullName"
                  label={i18next.t('full_name')}
                  placeholder="Greg Williams"
                  className={classes.genericInput}
                  value={this.state.fullName}
                  onChange={this.handleInputChange}
                  error={this.hasNameErrors()}
                  helperText={
                    this.hasNameErrors() ? (
                      <ErrorMessages show={this.getNameErrors()} messages={this.getNameErrorMessages()} />
                    ) : (
                      ''
                    )
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="password"
                  label={i18next.t('password')}
                  className={classes.genericInput}
                  InputProps={{ type: 'password' }}
                  value={this.state.password}
                  onChange={this.handleInputChange}
                  error={this.hasPasswordErrors()}
                  helperText={
                    this.hasPasswordErrors() ? (
                      <ErrorMessages
                        show={this.getPasswordErrors()}
                        messages={this.getPasswordErrorMessages(minLength)}
                      />
                    ) : (
                      ''
                    )
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <p className={classes.subText}>
                  <Trans>elavon_uses_your_email</Trans>
                </p>
              </Grid>
              <Grid item xs={12}>
                <PendingIcon show={this.state.pending} />
              </Grid>
              <Grid item xs={12}>
                <FormControl className={classes.buttonForm} fullWidth>
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.submitButton}
                    disabled={this.state.disabled}
                    type="submit"
                    id="register"
                  >
                    <Trans>continue_button</Trans>
                    <ChevronRight />
                  </Button>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Typography align="center" className={classes.errors}>
                  <ErrorMessages show={this.getServerErrors()} messages={this.getServerErrorMessages()} />
                </Typography>
              </Grid>
            </form>
          </CardContent>
        </Card>
        <Grid item xs={12}>
          <Typography variant="caption" align="center" className={classes.signInCaption}>
            <Trans>already_have_an_account</Trans>
            {' '}
            <a href={signInURL}>
              <Trans>sign_in</Trans>
            </a>
          </Typography>
        </Grid>
      </>
    );
  }

  private handleInputChange(event) {
    this.setState({ [event.target.id]: event.target.value });
    this.togglePristine(event.target.id);
    this.handleInputValidation(event.target);
  }

  // Country field doesn't seem to display an id, so they get their own handler.
  private handleCountryChange(event) {
    this.setState({ country: event.target.value });
  }

  // Turns the pristine state off when a field other than country is manipulated.
  private togglePristine(field) {
    const pristine = { ...this.state.pristine };

    switch (field) {
      case 'emailAddress':
        if (this.state.pristine.emailAddress) {
          pristine.emailAddress = false;
        }
        break;
      case 'fullName':
        if (this.state.pristine.fullName) {
          pristine.fullName = false;
        }
        break;
      case 'password':
        if (this.state.pristine.password) {
          pristine.password = false;
        }
        break;
    }

    this.setState({ pristine });
  }

  // Runs relevant validators and toggles errors.
  private handleInputValidation(target) {
    const field = target.id;
    const { value } = target;
    const errors = { ...this.state.errors };

    switch (field) {
      case 'emailAddress':
        errors.email.emailRequired = !this.requiredValidator(value);
        errors.email.emailPattern = !this.emailRegexValidator(value);
        errors.email.emailInUse = false;
        break;
      case 'fullName':
        errors.name.nameRequired = !this.requiredValidator(value);
        errors.name.namePattern = !this.nameRegexValidator(value);
        break;
      case 'password':
        errors.password.passwordRequired = !this.requiredValidator(value);
        errors.password.passwordMinLength = !this.minimumLengthValidator(value, passwordMinimumLength);
        errors.password.passwordPattern = !this.passwordRegexValidator(value);
        break;
    }

    this.setState({ errors }, () => this.checkFormValidity());
  }

  // Checks the state of the form and disables/enables the continue button.
  private checkFormValidity() {
    if (this.state.pending || this.isFormPristine() || this.isFormErroneous()) {
      this.setState({ disabled: true });
    } else {
      this.setState({ disabled: false });
    }
  }

  // If any field is pristine, return true. Else, false.
  private isFormPristine() {
    for (const field in this.state.pristine) {
      if (this.state.pristine[field]) {
        return true;
      }
    }
    return false;
  }

  private isFormErroneous() {
    return this.hasEmailErrors() || this.hasNameErrors() || this.hasPasswordErrors();
  }

  // Errors

  private hasEmailErrors() {
    return _.includes(this.getEmailErrors(), true);
  }

  private getEmailErrors() {
    return Object.keys(this.state.errors.email).map((key) => this.state.errors.email[key]);
  }

  private getEmailErrorMessages() {
    return [i18n.t('email_required_error'), i18n.t('email_regex_error'), i18n.t('email_in_use_error')];
  }

  private hasNameErrors() {
    return _.includes(this.getNameErrors(), true);
  }

  private getNameErrors() {
    return Object.keys(this.state.errors.name).map((key) => this.state.errors.name[key]);
  }

  private getNameErrorMessages() {
    return [i18n.t('name_required_error'), i18n.t('name_regex_error')];
  }

  private hasPasswordErrors() {
    return _.includes(this.getPasswordErrors(), true);
  }

  private getPasswordErrors() {
    return Object.keys(this.state.errors.password).map((key) => this.state.errors.password[key]);
  }

  private getPasswordErrorMessages(minLength) {
    return [i18n.t('password_required_error'), i18n.t('password_regex_error'), i18n.t('password_min_length_error', { minLength })];
  }

  private getServerErrors() {
    return Object.keys(this.state.errors.server).map((key) => this.state.errors.server[key]);
  }

  private getServerErrorMessages() {
    return [i18n.t('server_failure_error')];
  }

  // Field Validators - Return true if valid, false if invalid. Empty string is valid for everything except the required validator.

  private requiredValidator(value) {
    if (value === '') {
      return false;
    }
    return true;
  }

  private emailRegexValidator(value) {
    if (value === '') {
      return true;
    }
    return RegExp(emailValidationPattern).test(value);
  }

  private nameRegexValidator(value) {
    if (value === '') {
      return true;
    }
    return RegExp(nameValidationPattern).test(value);
  }

  private passwordRegexValidator(value) {
    if (value === '') {
      return true;
    }

    let count = 0;
    if (RegExp(lowercasePattern).test(value)) {
      count++;
    }
    if (RegExp(uppercasePattern).test(value)) {
      count++;
    }
    if (RegExp(digitPattern).test(value)) {
      count++;
    }
    if (RegExp(specialPattern).test(value)) {
      count++;
    }
    return count >= 3;
  }

  private minimumLengthValidator(value, num) {
    if (value === '') {
      return true;
    }
    return value.length >= num;
  }

  // Server Communication

  private createAccount(e: React.FormEvent) {
    e.preventDefault();
    const errors = { ...this.state.errors };
    errors.server.serverError = false;
    errors.server.emailInUse = false;
    this.setState({ pending: true, disabled: true, errors }, () => {
      grecaptcha.execute('6LcG9ncUAAAAAI7laZhfyrjCKUgr03x21rWAYpJe', { action: 'create_account' }).then((token) => {
        ARHttp({
          method: 'POST',
          url: '/sb/account/createaccount',
          body: {
            email: this.state.emailAddress,
            name: this.state.fullName,
            password: this.state.password,
            recaptchaResponse: token,
            offerCode: this.state.offerCode,
            jurisdictionCode: this.state.jurisdictionCode,
            locale: this.state.locale,
            subJurisdictionCode: this.state.subJurisdictionCode,
          },
        })
          .pipe(catchError(this.handleServerError))
          .subscribe(this.handleServerResponse);
      });
    });
  }

  private handleServerError(error) {
    const errors = { ...this.state.errors };
    errors.server.serverError = true;
    this.setState({ pending: false, disabled: false, errors });
    return of(undefined);
  }

  private handleServerResponse(response) {
    // Commenting out both responses causes normal flow, which in this case is a server error, as there is no server currently.
    // response = { responseId: 0, emailInUse: false }; // This redirects to the next screen.
    // response = { responseId: 0, emailInUse: true }; // This causes an email in use error.
    if (response !== undefined) {
      this.setState({ pending: false, disabled: false }, function () {
        if (response.emailInUse === false) {
          this.setState({ redirect: true });
        } else {
          const errors = { ...this.state.errors };
          errors.email.emailInUse = true;
          this.setState({ errors });
        }
      });
    }
  }
}

export default withStyles(pageStyles)(RegisterScreen);
